import siteData from '../siteData';
import ReactGA from 'react-ga4';

export function handleHashNav(section, callback) {
  return (e) => {
    e.preventDefault();

    const targetElement = document.getElementById(section);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }

    if (callback) {
      callback();
    }
  };
}

export function initStyles() {
  document.documentElement.style.setProperty(`--pri`, siteData.styles.pri);
  document.documentElement.style.setProperty(`--sec`, siteData.styles.sec);
  document.documentElement.style.setProperty(`--ter`, siteData.styles.ter);
}

export function initAnalytics() {
  if (siteData.analytics.on) {
    ReactGA.initialize(siteData.analytics.id);
    ReactGA.send({ hitType: 'pageview', page: window.location.origin });
  }
}